import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';

@Component({
  selector: 'hub-program-card',
  templateUrl: './hub-program-card.component.html',
  styleUrls: ['./hub-program-card.component.scss']
})
export class HubProgramCardComponent implements OnInit {
  @Input() learnspace!: Learnspace;
  @Input() checkInProgress = false;
  @Output() cardClick = new EventEmitter<void>();

  inProgress = false;

  constructor(private _coursesApiService: CoursesAPIService) { }

  ngOnInit() {
    if (!this.checkInProgress) return;
    // this._coursesApiService.hasSessionForLearnspace(this.learnspace.id).subscribe({
    //   next: exists => this.inProgress = exists,
    //   error: () => this.inProgress = false
    // });
  }

  get posterUrl(): string | null {
    // TODO: Check biggest resized variant instead of source (thumbnail is too small)
    return this.learnspace.postermedia?.path ?? null;
  }

  get ownerName(): string {
    const owner = this.learnspace.owner;
    if (!owner) return '';
    return [owner.first_name, owner.last_name].filter(Boolean).join(' ');
  }
}
